export default __webpack_public_path__ + "static/media/2262.4b6f0a28.png";